import { useEffect, useState } from 'react'
import { ViewersService } from 'utility'

export const GetViewersList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [total, setTotal] = useState(0)
    const [filter, setFilter] = useState({
        limit: 10,
        page: 0,
    })

    const fetchData = async () => {
        setLoading(true)
        try {
            const result = await ViewersService.get(filter)
            setTotal(result.total)
            setData(result.list)
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [filter])

    const updateFilter = (key, value) => {
        setFilter((prevFilters) => {
            if (typeof key === "object") {
                return { ...prevFilters, ...key };
            }
            return { ...prevFilters, [key]: value };
        });
    };

    const pageChanged = (page) => {
        setFilter((prev) => ({
            ...prev,
            page,
        }))
    }

    const pageSizeChanged = (limit) => {
        setFilter((prev) => ({
            ...prev,
            page: 0,
            limit,
        }))
    }

    const refetch = () => {
        fetchData()
    }

    return {
        data,
        setData,
        loading,
        error,
        total,
        updateFilter,
        filter,
        pageChanged,
        pageSizeChanged, // <-- added here
        refetch,
    }
}

export const GetBlockedViewersList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [total, setTotal] = useState(0)
    const [filter, setFilter] = useState({
        limit: 10,
        page: 0,
    })

    const fetchData = async () => {
        setLoading(true)
        try {
            const result = await ViewersService.getBlockedViewers(filter)
            setTotal(result.total)
            setData(result.list)
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [filter])

    const updateFilter = (key, value) => {
        setFilter((prevFilters) => {
            if (typeof key === "object") {
                return { ...prevFilters, ...key };
            }
            return { ...prevFilters, [key]: value };
        });
    };

    const pageChanged = (page) => {
        setFilter((prev) => ({
            ...prev,
            page,
        }))
    }

    const pageSizeChanged = (limit) => {
        setFilter((prev) => ({
            ...prev,
            page: 0,
            limit,
        }))
    }

    const refetch = () => {
        fetchData()
    }

    return {
        data,
        setData,
        loading,
        error,
        total,
        updateFilter,
        filter,
        pageChanged,
        pageSizeChanged, // <-- added here
        refetch,
    }
}
